export default __webpack_public_path__ + "static/media/mascot-sand-of-time.8043fd17.gif";